/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Feat3_TitleInputs */

const es_exp_mk_feat3_title = /** @type {(inputs: Exp_Mk_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O publica la tuya`)
};

const gl_exp_mk_feat3_title = /** @type {(inputs: Exp_Mk_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou publica a túa`)
};

const en_exp_mk_feat3_title = /** @type {(inputs: Exp_Mk_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or publish yours`)
};

/**
* | output |
* | --- |
* | "Or publish yours" |
*
* @param {Exp_Mk_Feat3_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_feat3_title = /** @type {((inputs?: Exp_Mk_Feat3_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Feat3_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_feat3_title(inputs)
	if (locale === "en") return en_exp_mk_feat3_title(inputs)
	return es_exp_mk_feat3_title(inputs)
});